import PropTypes from 'prop-types';
import { CurrencyPropType } from '../prop-types/currency';

export const CustomsItemPropType = PropTypes.shape({
  description: PropTypes.string,
  quantity: PropTypes.number,
  unitPrice: CurrencyPropType,
  harmonizedTariffCode: PropTypes.string,
  originCountryCode: PropTypes.string,
  fulfillmentPlanItemId: PropTypes.string,
  declarationKey: PropTypes.string,
});

/**
 * @typedef {object} CustomsItemsPropType
 * @property {string} description
 * @property {number} quantity
 * @property {CurrencyPropType} unitPrice
 * @property {string} harmonizedTariffCode
 * @property {string} originCountryCode
 * @property {string} fulfillmentPlanItemId
 * @property {string} declarationKey
 */
